import { formatYYYY_MM_DD } from "./dateFormating";

export const groupMessagesByDate = (messages) => {
    const sortedGroups = messages.reduce((groups, message) => {
        const date = formatYYYY_MM_DD(message.createdAt);
        if (!groups[date]) {
            groups[date] = [];
        }
        groups[date].push(message);
        return groups;
    }, {});

    for (const date of Object.keys(sortedGroups).sort((a, b) => new Date(b) - new Date(a))) {
        sortedGroups[date].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    }

    return sortedGroups
};

export const sortGroupdArray = (dates = []) => {
    return [...dates].sort((a, b) => new Date(a) - new Date(b));
}
